import styled from 'styled-components';
import ds from '../../utils/designSystem';

export const NavbarLogo = styled.div`
  border-bottom: ${props => (props.isOpen ? '1px solid #343333' : null)};
  padding: 15px;

  img {
    margin: auto 0;
  }
`;

export const IconImg = styled.img`
  width: fit-content;
  margin: 25px auto 0px;
`;

export const BurguerMenu = styled.div`
  color: #cccccc;
  float: right;
  font-size: 20px;
  cursor: pointer;
  //  margin: 15px;
`;

export const NavbarDiv = styled.div`
  overflow: auto;
  background: ${ds.colors.black};
  width: ${props => (props.isOpen ? '250px' : '40px')};
  display: inline-block;
  height: 100vh;
  text-decoration: none;

  a {
    text-decoration: none;
  }

  @media only screen and (min-width: 768px) {
    width: ${props => (props.isOpen ? '250px' : '40px')};
  }

  @media only screen and (max-width: 500px) {
    height: ${props => (props.isOpen ? '100%' : '45px')};
    width: 100%;
    position: absolute;
    z-index: 5;
  }
`;
